import { render, staticRenderFns } from "./AddressesPopup.vue?vue&type=template&id=4d4d2a8e&scoped=true&"
import script from "./AddressesPopup.vue?vue&type=script&lang=ts&"
export * from "./AddressesPopup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4d2a8e",
  null
  
)

export default component.exports